import { DEFAULT_TIME_TO_EXPIRES } from '@belezanaweb/utils/cookie';
import { isClient } from '@belezanaweb/utils/is';
export var cookiePrefix = 'abTest';
export var setCookie = function setCookie(cookie) {
  return document.cookie = cookie;
};
export var createCookie = function createCookie(_ref) {
  var name = _ref.name,
      value = _ref.value,
      time = _ref.time;
  var cookieName = name.includes(cookiePrefix) ? name : "".concat(cookiePrefix, "-").concat(name);
  var cookie = formatToCookiePattern({
    name: cookieName,
    value: value,
    time: time
  });
  setCookie(cookie);
};
export var formatToCookiePattern = function formatToCookiePattern(_ref2) {
  var name = _ref2.name,
      value = _ref2.value,
      time = _ref2.time;
  var now = new Date();
  var timeToExpires = time || DEFAULT_TIME_TO_EXPIRES;
  var secure = document.location.port ? '' : 'secure';
  now.setTime(now.getTime() + timeToExpires); // TODO: create options to this

  return "".concat(name, "=").concat(value, "; expires=").concat(now.toGMTString(), "; domain=").concat(document.domain.replace(/^(www|loja|checkout)\./, ''), "; path=/; ").concat(secure);
};
export var getCookieByName = function getCookieByName(cookieName) {
  if (!isClient()) {
    return '';
  }

  var pattern = new RegExp("".concat(cookieName, "=([^;]+)"));
  var match = document.cookie.match(pattern);
  return match ? match[1] : '';
};
export var getCurrentAbTestsWithValues = function getCurrentAbTestsWithValues() {
  var cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var abTestsNames = cookies[cookiePrefix] || getCookieByName(cookiePrefix);
  return abTestsNames.split(',').map(function (testName) {
    var cookieName = "".concat(cookiePrefix, "-").concat(testName);
    var cookieValue = cookies[cookieName] || getCookieByName(cookieName);
    return "".concat(testName, "=").concat(cookieValue);
  }).join(';');
};
export * from '@belezanaweb/utils/constants';